import { render, staticRenderFns } from "./StudyRecordCourse.vue?vue&type=template&id=075feb99"
import script from "./StudyRecordCourse.vue?vue&type=script&lang=ts"
export * from "./StudyRecordCourse.vue?vue&type=script&lang=ts"
import style0 from "./StudyRecordCourse.vue?vue&type=style&index=0&id=075feb99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports